module.exports = __webpack_public_path__ + "static/media/study 220628.a34f04ea.png";